import TablePaginadaBasic, { ITablePaginadaBasicProps } from "@/Components/Base/Table/TablePaginadaBasic";
import { AxiosResponse } from "axios";
import TrabalhoLog from "@/Models/Sistema/Trabalho/TrabalhoLog";
import { useState } from "react";
import { Button, Modal } from "antd";
import { LineChartOutlined, PlusOutlined } from "@ant-design/icons";
import { useConciliacaoAuttarLogDetalhe } from "@/Services/Financeiro/Conta/ConciliacaoAuttarService";
import ResponsiveAntdTable from "@/Components/ResponsiveAntdTable";
import { EnumTrabalhoTipo } from "@/Models/Sistema/Trabalho/TrabalhoTipo";

export interface IConciliacaoLogTableBasicProps extends ITablePaginadaBasicProps<TrabalhoLog> {
    onSuccess?:(response:AxiosResponse<void, any>, input:TrabalhoLog) => void;
    codTrabalhoTipo:EnumTrabalhoTipo;
}
export default function ConciliacaoLogTableBasic({
    onSuccess,
    codTrabalhoTipo,
    ...rest
}: IConciliacaoLogTableBasicProps) {
    return <TablePaginadaBasic
        {...rest}
        rowKey={(m) => m.codigo.toString()}
        disableResponsiveness={true}
        tableLayout="auto"
        scroll={{
            x: true,
        }}
        showHeader={true}
        minColWidthIfResponsivenessDisabled={"120px"}
        csv={{
            enabled : true
        }}
        columns={[
            // {
            //     key : "codigo",
            //     title : "#",
            //     dataIndex : ["codigo"],
            //     // breakpoints : { xs : 8, sm : 8, md : 4, lg : 4, xl : 3, xxl : 3 }
            // },
            {
                key : "identificador",
                title : "Linha",
                dataIndex : ["identificador"],
                // breakpoints : { xs : 8, sm : 8, md : 5, lg : 5, xl : 3, xxl : 3 }
            },
            {
                key : "Erro",
                title : "Código erro",
                dataIndex : ["statusCode"],
                render: (value: number, record) => `${value} - ${record.status}`
                // breakpoints : { xs : 8, sm : 8, md : 5, lg : 5, xl : 3, xxl : 3 }
            },
            {
                key : "dataCriacao",
                title : "Criado",
                dataIndex : ["dataCriacao"],
                render: (value: Date) => value.toLocaleString().replace(',', '').substring(0, 16),
                // breakpoints : { xs : 12, sm : 12, md : 5, lg : 5, xl : 3, xxl : 3 }
            },
            {
                key : "mensagem",
                title : "Mensagem",
                dataIndex : ["mensagem"],
                // breakpoints : { xs : 24, sm : 24, md : 24, lg : 24, xl : 9, xxl : 9 }
            },
            {
                key : "acoes",
                title : "Ações",
                dataIndex : ["codigo"],
                // breakpoints : { xs : 24, sm : 12, md : 6, lg : 6, xl : 3, xxl : 3 },
                render(value, record, index) {
                    return <LogDetalhe
                        codTrabalhoTipo={codTrabalhoTipo}
                        codTrabalho={record.codTrabalho}
                        linha={Number.parseInt(record.identificador ?? "0")}
                    />
                },
                csv : {
                    ignore : true
                }
            }
        ]}
    />
}

function LogDetalhe ({
    codTrabalho,
    linha,
    codTrabalhoTipo
}:{
    codTrabalho : number;
    linha : number;
    codTrabalhoTipo:EnumTrabalhoTipo;
}) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const {
        data,
        isLoading,
        isPending
    } = useConciliacaoAuttarLogDetalhe({
        codTrabalhoTipo,
        codTrabalho : codTrabalho,
        linha : linha,
        enabled : isModalOpen
    });

  return (
    <>
      <Button type="dashed" icon={<PlusOutlined />} size={"small"} onClick={showModal}></Button>
      <Modal
        title="Detalhes"
        cancelButtonProps={{ style : { display : "none" } }}
        open={isModalOpen}
        width={"90vw"}
        okText="Fechar"
        onOk={handleCancel}
        onCancel={handleCancel}
        destroyOnClose={true}
      >
        <ResponsiveAntdTable
            dataSource={data?.data != undefined ? [data?.data] : []}
            loading={isLoading || isPending ? true : undefined}
            rowKey={(m, i) => (i ?? -1).toString()}
            disableResponsiveness={true}
            tableLayout="auto"
            scroll={{
                x: true,
            }}
            showHeader={true}
            minColWidthIfResponsivenessDisabled={"120px"}
            csv={{
                enabled : true
            }}      
            columns={
                Object.keys(data?.data ?? {})
                    .map(m => {
                    return {
                        key : m,
                        title : m,
                        dataIndex : [m]
                    }
                })
            }
        />
      </Modal>
    </>
  );
};